import type { ProductCreditCardConfig } from '../../@types/context/product-credit-card-config.types';

export const creditCardNoConfig: ProductCreditCardConfig = {
  config: {
    amount: {
      min: 10_000,
      max: 200_000,
      default: 70_000,
      step: 10_000,
    },
  },
};
